<template>
  <div>
    <v-card height="428px" flat>
      <div style="overflow: auto; max-height: 374px">
        <v-data-table
          class="fs-table-interacoes"
          :loading="loading"
          loading-text="Carregando interações, aguarde..."
          no-data-text="Não há interações com o pedido selecionado..."
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :sort-desc="sortDesc"
          :headers="headers"
          :items="interacoes"
          disable-pagination
          hide-default-footer
          :limit="10"
          sort-by="id"
          item-key="id"
          show-expand
          hide-action
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td class="pa-4" :colspan="headers.length">{{ item.descricao }}</td>
          </template>
        </v-data-table>
      </div>

      <!-- <v-divider style="margin: 12px 0px 12px 0px"></v-divider> -->
      <v-card-actions style="padding: 0px; position: absolute; bottom: 0; right: 0">
        <v-spacer></v-spacer>
        <v-btn color="#2A2F50" @click="dialog = true" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-message-text</v-icon>
          Adicionar Interação
        </v-btn>
        <v-btn color="warning" @click="fecharDialog()" dark small>
          <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- DIALOG ADD INTERAÇÃO -->
    <v-dialog v-model="dialog" max-width="700px">
      <v-card class="pa-3 pt-5" flat>
        <h3 class="ml-3">Adicionar Interação ao Pedido</h3>
        <v-divider style="margin: 17px 0px 12px 0px"></v-divider>
        <v-form autocomplete="off" class="mt-n2">
          <v-radio-group v-model="tipo" row>
            <v-radio color="#2A2F50" label="Envio de Email" value="Envio de Email"></v-radio>
            <v-radio color="#2A2F50" label="Contato Telefônico" value="Contato Telefônico"></v-radio>
            <v-radio color="#2A2F50" label="Feedback do Cliente" value="Feedback do Cliente"></v-radio>
          </v-radio-group>
          <v-textarea
            label="Descrição *"
            placeholder=" "
            rows="8"
            spellcheck="false"
            class="mt-n3 mb-n5"
            v-model="descricao"
            outlined
          ></v-textarea>
        </v-form>
        <v-divider style="margin: 12px 0px 12px 0px"></v-divider>
        <v-card-actions style="padding: 0px">
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" @click="saveInteracao()" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-content-save</v-icon>
            Salvar
          </v-btn>
          <v-btn color="warning" @click="dialog = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as interacaoApi from '@/api/interacao'
import { mapMutations, mapActions } from 'vuex'
import moment from 'moment'

export default {
  props: {
    itemMostrarDetalhes: Object,
    fecharDialog: Function
  },
  data () {
    return {
      tipo: 'Envio de Email',
      descricao: '',
      headers: [
        { text: '#', value: 'id' },
        { text: 'USUÁRIO', value: 'pessoa.nome' },
        { text: 'TIPO', value: 'tipo' },
        { text: 'DATA/HORA', value: 'created_at' },
        { text: 'DETALHES', align: 'center', value: 'data-table-expand' }
      ],
      interacoes: [],
      expanded: [],
      singleExpand: false,
      dialog: false,
      sortDesc: true,
      loading: true
    }
  },

  async mounted () {
    moment.locale('pt-br')
    this.loadInteracoes()
  },

  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    ...mapActions({
      getPedido: 'pedidos/getPedido'
    }),
    async loadInteracoes () {
      this.loading = true
      const pedido = await this.getPedido(this.itemMostrarDetalhes.id)
      this.interacoes = pedido[0].interacoes.map(item => {
        item.created_at = moment(item.created_at).format('L LT')
        return item
      })
      this.loading = false
    },
    async saveInteracao () {
      if (this.descricao.length > 0) {
        const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
        const data = {
          ecommerce_carrinho_id: this.itemMostrarDetalhes.id,
          usuario_id: userInfo.pessoa,
          cliente_id: this.itemMostrarDetalhes.pessoa_id,
          tipo: this.tipo,
          descricao: this.descricao
        }
        try {
          this.dialog = false
          await interacaoApi.add({}, data)
          await this.loadInteracoes()
          this.descricao = ''
          this.setSnackbar({ msg: 'Interação Adicionada com Sucesso!', color: 'green' })
        } catch (error) {
          this.setSnackbar({ msg: `Ocorreu um erro! ${error}` })
        }
      } else {
        this.setSnackbar({ msg: 'Informe a Descrição da Interação!' })
      }
    }
  }
}
</script>

<style scoped>
  .fs-table-interacoes {
    border: 1px solid rgb(218, 218, 218);
    border-bottom: 2px solid rgb(218, 218, 218);
    border-radius: 5px;
  }
</style>
